import { RutterJobStatus } from '@40seas/entities/rutter';
import { EnumColor } from '@40seas/frontend/common/providers';

export const rutterJobStatusColorMapping = {
    [RutterJobStatus.Prequeued]: 'info',
    [RutterJobStatus.Success]: 'success',
    [RutterJobStatus.Failed]: 'error',
    [RutterJobStatus.InProgress]: 'warning',
    [RutterJobStatus.Pending]: 'default',
} as { [key in RutterJobStatus]: EnumColor };
